<template>
  <div class="login">
    <div class="card login-card card-design">
      <div class="mobile-head">
        <img
          class="img-background-fade"
          src="../assets/spree/rutsche_aussen.jpg"
          alt="background"
        />
      </div>
      <div class="card-body">
        <div class="card-headline">
          <div class="logo logoStart" />
          <!--<img class="logo" src="../assets/logo.svg" alt="BlackJack" />-->
          <h3 class="custom-headline" v-text="$ml.get('title')"></h3>
          <div v-text="$ml.get('text')"></div>
          <LangChooser />
        </div>
        <div v-if="!isLoggedIn" class="card-input-wrapper">
          <div class="card-input-container">
            <!-- nickname -->
            <div class="card-input-description" v-text="$ml.get('name')"></div>
            <b-input-group id="input-group-username">
              <b-input-group-prepend>
                <span class="input-group-text">
                  <UserIcon title="Username" />
                </span>
              </b-input-group-prepend>
              <b-form-input
                id="input-username"
                v-model.trim="username"
                :state="validUsername"
                :maxlength="20"
                aria-describedby="input-username-feedback"
                type="text"
                required
                placeholder="MaxMuster19"
                class="input-with-icon"
              ></b-form-input>
              <b-form-invalid-feedback id="input-username-feedback">
                <span v-text="$ml.get('validation')"></span>
              </b-form-invalid-feedback>
            </b-input-group>
            <hr class="card-hr" />
            <!-- Password -->
            <div
              class="card-input-description"
              v-text="$ml.get('labelPassword')"
            ></div>
            <b-input-group id="input-group-password" :state="validPassword">
              <b-input-group-prepend>
                <span class="input-group-text">
                  <PasswordIcon title="Passwort" />
                </span>
              </b-input-group-prepend>
              <b-form-input
                id="input-password"
                v-model.trim="password"
                :state="validPassword"
                :maxlength="4"
                aria-describedby="input-password-feedback"
                type="password"
                required
                :placeholder="$ml.get('placeholderCode')"
                class="input-with-icon"
                @keydown.enter="logMeIn"
              ></b-form-input>
              <b-form-invalid-feedback
                id="input-password-feedback"
                v-text="$ml.get('validationPassword')"
              ></b-form-invalid-feedback>
            </b-input-group>
          </div>
        </div>
        <div v-if="!isLoggedIn" class="card-body-confirm">
          <button
            v-if="!isPending"
            class="btn start-btn"
            :class="{
              disabled: username === '' || !validPassword || !validUsername,
            }"
            @click="logMeIn"
          >
            <span v-if="token === ''" v-text="$ml.get('anmelden')"></span>
            <span v-else v-text="$ml.get('connectProfile')"></span>
          </button>
          <div v-else v-text="$ml.get('wait')"></div>
        </div>
        <div v-if="isLoggedIn" class="card-body-confirm missing-token">
          <div v-if="isLoggedIn">
            <div v-if="$route.query.user" v-html="$ml.get('LoggedIn')"></div>
            <div v-else v-text="$ml.get('LoggedIn')"></div>
            <button class="btn" @click="logout">Logout</button>
          </div>
        </div>
        <Footer />
      </div>
    </div>
    <Notification
      :show="notification.show"
      :title="notification.title"
      :text="notification.text"
      :error="error"
      @okay="notification.show = false"
    />
  </div>
</template>

<script>
import { mapActions } from "vuex";
import { mapGetters } from "vuex";
import UserIcon from "vue-material-design-icons/Account";
import PasswordIcon from "vue-material-design-icons/Lock";
import Footer from "../components/Footer";
import Notification from "../components/Notification";
import LangChooser from "../components/LangChooser";
import { MLBuilder } from "vue-multilanguage";

export default {
  name: "Login",
  components: {
    Notification,
    UserIcon,
    PasswordIcon,
    Footer,
    LangChooser,
  },
  data() {
    return {
      username: "",
      password: "",
      token: "",
      notification: {
        show: false,
        title: "",
        text: "",
      },
      error: {},
    };
  },
  computed: {
    ...mapGetters("authentication", ["isLoggedIn", "name", "isPending"]),
    validPassword() {
      let length = this.password.length;
      if (length === 0) {
        return null;
      } else if (length === 4) {
        const pattern = new RegExp("^[0-9]{4}");
        return pattern.test(this.password);
      } else {
        return false;
      }
    },
    validUsername() {
      let length = this.username.length;
      if (length === 0) {
        return null;
      } else return length >= 3;
    },
    mlLoggedIn() {
      return new MLBuilder("loggedIn").with("name", this.username);
    },
    mlLoggedInAlternative() {
      return new MLBuilder("loggedIn")
        .with("newUser", this.$route.query.user)
        .with("name", this.username);
    },
  },
  mounted() {
    if (typeof this.$route.query.user !== "undefined") {
      this.username = this.$route.query.user;
    }
    if (typeof this.$route.query.token !== "undefined") {
      this.token = this.$route.query.token;
    }
  },
  methods: {
    ...mapActions("authentication", ["login", "logout"]),
    async logMeIn() {
      try {
        await this.login({
          username: this.username,
          password: this.password,
          token: this.token,
        });
        this.username = "";
        this.password = "";
        this.$router.push({ name: "home" });
      } catch (e) {
        if (typeof e.response !== "undefined") {
          this.error = e.response;
          this.showNotification("", "");
        } else {
          this.e = {};
          this.showNotification(
            "Oops!",
            "Da ist etwas schief gelaufen. Bitte probiere es erneut!"
          );
          console.log(e);
        }
        this.password = "";
      }
    },
    showNotification(title, text) {
      console.log(title, text);
      this.notification.title = title;
      this.notification.text = text;
      this.notification.show = true;
    },
  },
};
</script>

<style scoped></style>
